<template>
    <div class="npc">
        <!-- NPC 列表 + 浮层（头像/任务标记/操作按钮） -->
        <npcFloat
            @talk="onTalk"
            @ask="onAsk"
            @accept="onAccept"
            @complete="onComplete"
            @give="onGive"
            @refuse="onRefuse"></npcFloat>
        <!-- 交谈框 -->
        <npcTalk ref="npcTalk" @task-finished="onTaskFinished"></npcTalk>
        <!-- 任务弹窗 -->
        <npcTaskDialog ref="npcTaskDialog" @close-talk="onCloseTalk"></npcTaskDialog>
        <!-- 背包弹窗 -->
        <npcPocketDialog ref="npcPocketDialog"
            @task-finished="onTaskFinished"
            @open-talk-loading="onOpenTalkLoading"
            @show-talk-msg="onShowTalkMsg"
            @close-talk="onCloseTalk"></npcPocketDialog>
    </div>
</template>

<script>
import npcFloat from './npcFloat'
import npcTalk from './npcTalk'
import npcTaskDialog from './npcTaskDialog'
import npcPocketDialog from './npcPocketDialog'
export default {
  name: 'npclist',
  components: {
    npcFloat,
    npcTalk,
    npcTaskDialog,
    npcPocketDialog
  },
  methods: {
    onTalk: function(npcId) {
      this.$refs.npcTalk.showtalk(npcId);
    },
    onAsk: function(npcId) {
      this.$refs.npcTalk.askNpc(npcId);
    },
    onAccept: function(npcId) {
      this.$refs.npcTaskDialog.acceptTask(npcId);
    },
    onComplete: function(npcId) {
      this.$refs.npcTaskDialog.completeTask(npcId);
    },
    onGive: function(npcId) {
      this.$refs.npcPocketDialog.openPocket(npcId);
    },
    onRefuse: function(npcId) {
      this.$refs.npcTaskDialog.refuseTask(npcId);
    },
    // 交谈/询问/给道具完成任务后，统一在任务弹窗展示完成信息
    onTaskFinished: function(respData) {
      this.$refs.npcTaskDialog.finishTask(respData);
    },
    onOpenTalkLoading: function() {
      this.$refs.npcTalk.openTalkLoading();
    },
    onShowTalkMsg: function(msg) {
      this.$refs.npcTalk.showNpcTalk(msg);
    },
    onCloseTalk: function() {
      this.$refs.npcTalk.hiddentalkshow();
    }
  }
}
</script>

<style scoped>
.npc {
	height:100px;
	position:relative;
}
@media (max-width: 768px) {
  .npc {
    height: auto;
    min-height: auto;
  }
}
</style>
